import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./MatchDetails.css";
import NavbarSidebarWrapper from "../../../components/navbarSidebarWrapper";
import FnMatchTabs from "../../../components/FnMatchTabs";
import actions from "../../../redux/actions";
import { saveMatchPlayers } from "../../../utils/playerSession";

function Contests() {

  const navigate = useNavigate();
  const { matchId } = useParams();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [players, setPlayers] = useState([]);

  const [matchDetails, setMatchDetails] = useState({
    teamHomeName: "",
    teamAwayName: "",
    teamHomeCode: "",
    teamAwayCode: "",
    teamHomeFlagUrl: "https://flagcdn.com/w40/in.png",
    teamAwayFlagUrl: "https://flagcdn.com/w40/au.png",
  });


  useEffect(() => {

    if (matchId) {
      fetchSquadData();
    }
  }, [matchId]);

  const fetchSquadData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Make sure actions exists
      const response = await actions.getPlayersByMatch(matchId);

      const data = response?.data;

      if (data?.Status) {

        const squadData = Array.isArray(data.Result) ? data.Result : [];
        console.log("matachid",matchId,squadData);
        
        saveMatchPlayers(matchId, squadData);

        const formattedPlayers = squadData.map((player) => ({
          id: player.id,
          name: player.name,
          code: player.country?.substring(0, 3).toUpperCase() || "TBD",
          role: player.role || "Unknown",
          credits: player.credits || 0,
          isSelected: false,
          playing11: false,
          imageUrl:
            player.playerImg || "https://via.placeholder.com/80x80?text=Player",
        }));

        const countries = [
          ...new Set(squadData.map((p) => p.country).filter(Boolean)),
        ];

        const [teamA, teamB] =
          countries.length >= 2 ? countries : ["Team A", "Team B"];

        setMatchDetails((prev) => ({
          ...prev,
          teamHomeCode: teamA.substring(0, 3).toUpperCase(),
          teamAwayCode: teamB.substring(0, 3).toUpperCase(),
          teamHomeName: teamA,
          teamAwayName: teamB,
        }));

        setPlayers(formattedPlayers);

      } else {
        setPlayers([]);
      }

    } catch (err) {
      console.error("Error fetching squad:", err);
      setError("Failed to load players.");
      setPlayers([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <NavbarSidebarWrapper>
      <div className="content-wrapper me-0 mb-4">

        <div className="top-container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <span
                className="back-btn text-white"
                onClick={() => navigate(-1)}
              >
                ←
              </span>
              <h1 className="match-title text-white">
                {matchDetails.teamAwayCode} vs {matchDetails.teamHomeCode}
              </h1>
            </div>
          </div>
        </div>

        <FnMatchTabs matchDetails={matchDetails}/>

      </div>
    </NavbarSidebarWrapper>
  );
}

export default Contests;
